module.exports = __webpack_public_path__ + "media/pt_pt_s2_Cesaria.848aeac2.oga";